import React from "react";
import SignatureCanvas from "react-signature-canvas";
import PropTypes from "prop-types";
import { useRef, useState } from "react";

const SignaturePopup = ({
  clientSignatureText = "Client Signature",
  onClose,
  onClear,
  onConfirm,
  primaryColor = "#1F3047",
  secondaryColor = "#349AC8",
  textColor = "#181818",
  placeholderColor = "rgba(112, 112, 112, 0.5)",
  onSave,
}) => {
  const sigCanvas = useRef(null);
  const [signature, setSignature] = useState(null);

  const handleClear = () => {
    sigCanvas.current.clear();
    setSignature(null);
  };

  const handleEndSignature = () => {
    if (!sigCanvas.current.isEmpty()) {
      const sigData = sigCanvas.current.toDataURL();
      console.log("Captured Signature Data:", sigData); // Debug log
      setSignature(sigData);
    }
  };

  const handleConfirmClick = () => {
    if (signature) {
      onConfirm(signature);
    } else {
      alert("Please provide a signature.");
    }
  };
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        padding: "16px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "500px",
          padding: "24px",
          position: "relative",
          background: "white",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            right: "16px",
            top: "16px",
            width: "24px",
            height: "24px",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          aria-label="Close signature popup"
        >
          <div
            style={{
              width: "16px",
              height: "2px",
              backgroundColor: primaryColor,
              transform: "rotate(45deg)",
              position: "relative",
            }}
          >
            <div
              style={{
                width: "16px",
                height: "2px",
                backgroundColor: primaryColor,
                transform: "rotate(-90deg)",
                position: "absolute",
                top: 0,
                left: 0,
              }}
            />
          </div>
        </button>

        {/* Signature Area */}
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <div
            style={{
              color: textColor,
              fontSize: "14px",
              fontFamily: '"FONTSPRING DEMO - Commuters Sans", sans-serif',
              fontWeight: 400,
              lineHeight: "1.4",
            }}
          >
            {clientSignatureText}
          </div>
          <div
            style={{
              width: "100%",
              height: "200px",
              background: "white",
              borderRadius: "8px",
              border: `1px solid ${secondaryColor}`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* <div style={{
              color: placeholderColor,
              fontSize: '48px',
              fontFamily: '"Turbinado Pro", cursive',
              fontWeight: 400,
              textAlign: 'center',
              userSelect: 'none'
            }}>
              {clientSignatureText}
            </div> */}
            <SignatureCanvas
              penColor="black"
              canvasProps={{
                width: 500,
                height: 200,
                className: "sigCanvas",
                style: {
                  border: "1px solid lightgray",
                  backgroundColor: "#f5f5f5",
                },
                placeholderColor: { clientSignatureText },
              }}
              ref={sigCanvas}
              onEnd={handleEndSignature}
              // disabled={!isValidStaffId}
            />
            {!signature && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "gray",
                  pointerEvents: "none", // Allows clicks to pass through to the canvas
                  fontStyle: "italic",
                  textAlign: "center",
                  width: "100%",
                  color: placeholderColor,
                  fontSize: "48px",
                  fontFamily: '"Turbinado Pro", cursive',
                  fontWeight: 400,
                  textAlign: "center",
                  userSelect: "none",
                }}
              >
                {clientSignatureText}
              </div>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          <button
            // onClick={onClear}
            onClick={handleClear}
            style={{
              padding: "12px 24px",
              borderRadius: "16px",
              border: `1px solid ${secondaryColor}`,
              background: "white",
              color: primaryColor,
              fontSize: "16px",
              fontFamily: '"FONTSPRING DEMO - Commuters Sans", sans-serif',
              fontWeight: 400,
              cursor: "pointer",
              minWidth: "160px",
              transition: "all 0.2s ease",
              ":hover": {
                background: "#f5f5f5",
              },
            }}
          >
            Clear Signature
          </button>
          <button
            // onClick={onConfirm}
            onClick={handleConfirmClick}
            style={{
              padding: "12px 24px",
              borderRadius: "16px",
              border: "none",
              background: secondaryColor,
              color: "white",
              fontSize: "16px",
              fontFamily: '"FONTSPRING DEMO - Commuters Sans", sans-serif',
              fontWeight: 400,
              cursor: "pointer",
              minWidth: "160px",
              transition: "all 0.2s ease",
              ":hover": {
                background: "#2a7fa5",
              },
            }}
          >
            Confirm Signature
          </button>
        </div>
      </div>
    </div>
  );
};

SignaturePopup.propTypes = {
  clientSignatureText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  textColor: PropTypes.string,
  placeholderColor: PropTypes.string,
};

export default SignaturePopup;
